function synchronizeUpsellVariant(select) {
  const card = select.closest('[data-clearvero-upsell-card]');
  const option = select.selectedOptions[0];
  if (!card || !option) return;

  const variantInput = card.querySelector('input[name="id"]');
  const price = card.querySelector('[data-clearvero-upsell-price]');
  const compare = card.querySelector('[data-clearvero-upsell-compare]');

  if (variantInput instanceof HTMLInputElement) variantInput.value = select.value;
  if (price) price.textContent = option.dataset.price || '';

  if (compare) {
    const comparePrice = option.dataset.compare || '';
    compare.textContent = comparePrice;
    compare.toggleAttribute('hidden', comparePrice === '');
  }
}

document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLSelectElement)) return;
  if (!event.target.matches('[data-clearvero-upsell-variant]')) return;
  synchronizeUpsellVariant(event.target);
});
